import actions from './actions'

export default function ExternalInvoiceLogsReducer(state = { loading: false }, action) {
  switch (action.type) {
    case actions.REQUESTING:
      return {
        ...state,
        loading: true,
        editing: null,
        saveSuccess: false,
      }
    case actions.LIST_EXTERNALINVOICELOG:
      return {
        ...state,
        result: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.EDIT_EXTERNALINVOICELOG:
      return {
        ...state,
        editing: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.RESET_EXTERNALINVOICELOG:
      return {
        ...state,
        editing: null,
        loading: false,
        saveSuccess: false,
      }
    case actions.NEW_EXTERNALINVOICELOG:
      return {
        ...state,
        editing: { externalInvoiceLogID: 0 },
        loading: false,
        saveSuccess: false,
      }
    case actions.CREATE_EXTERNALINVOICELOG_RECIEVED ||
      actions.UPDATE_EXTERNALINVOICELOG_RECIEVED ||
      actions.DELETE_EXTERNALINVOICELOG_RECIEVED:
      return {
        ...state,
        editing: { externalInvoiceLogID: 0 },
        loading: false,
        saveSuccess: true, // mark
      }
    case actions.RESPONSE_ERROR:
      return {
        ...state,
        loading: false,
        error: true,
        saveSuccess: false,
        message: action.message,
      }
    default:
      return state
  }
}
